module.exports = __webpack_public_path__ + "static/media/Bay8.27bd740e.JPG";